module.exports = function getResource(label, vars = []) {
    const resources = {
        freeShipping: 'Vous pouvez maintenant bénéficier de la livraison gratuite!'
    };

    return resources[label];
};
